import { useProductCategories } from "@/common/hooks/queries/useProductCategories";
import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { ProductCategoryData } from "@/common/types/productCategory.type";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import DashboardFilterBadge from "../DashboardFilterBadge";

const DashboardFilterProductCategoryBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: productCategoriesOptions,
  } = useProductCategories({
    filters: {
      search,
    },
    mapper: Mapper.mapToOptions<ProductCategoryData>({
      labelFieldName: 'display_name',
      valueFieldName: 'id',
    }),
  });

  return (
    <DashboardFilterBadge
      filterKey={DashboardFilters.ProductCategory}
      options={productCategoriesOptions}
      filters={filters}
      setFilters={setFilters}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterProductCategoryBadge;
